define('sentient/aba/Sounds',[
	'backbone',
	'underscore',
	'loglevel',
	'exports'
	],
	function(Backbone, _, log, exports) {

		log.trace('Sounds.js');

		var Sounds = function(parentEl) {
			_.extend(this, Backbone.Events);
			var self = this;
			var $parentEl = this.$parentEl = $(parentEl);
			var audioEl = this.audioEl = document.createElement('audio');
			var $audioEl = this.$audioEl = $(audioEl).attr({
				'preload': 'auto',
				'class': 'aba-game-sounds'
			});

			$audioEl
      .append($('<source>').attr({ 'type': 'audio/wav', 'src': '/sounds/aba-game-sounds.wav' }))
      .append($('<source>').attr({ 'type': 'audio/mpeg', 'src': '/sounds/aba-game-sounds.mp3' }))
      .append($('<source>').attr({ 'type': 'audio/ogg', 'src': '/sounds/aba-game-sounds.ogg' }))
      .append($('<source>').attr({ 'type': 'audio/mp4', 'src': '/sounds/aba-game-sounds.m4a' }));
      $parentEl.append($audioEl);

      //log.debug($parentEl);
      var playedOnce = false;
      this.stop = function() {
        //log.debug({"audio":$audioEl.get(0)});
        if (self.timeoutHandle) {
         clearTimeout(self.timeoutHandle);
         delete self.timeoutHandle;
       }
       if (playedOnce) {
         self.$audioEl.each(function(index, element) {
          try {
            if (typeof(element.pause) == 'function') {
              element.pause();
            }

          } catch (err) {
           log.error('Error: '+ err);
         }
       });
       }
     };
     this.playSilence = function() {

      self.stop();
      self.$audioEl.each(function(index, element) {
       try {
        if (typeof(element.play) == 'function') {
          element.play();
        }
      } catch (err) {
        log.error('Error: '+ err);
      }
      self.timeoutHandle = setTimeout(function() {
        delete self.timeoutHandle;
        self.stop();
      },500);
      playedOnce = true;
    });

    };
    this.playCorrect = function() {
      self.stop();
      if (playedOnce) {
       self.$audioEl.each(function(index, element) {
        try {
         element.currentTime = 1.05;
       } catch (err) {
         log.error('Error: '+ err);
       }
     });
     }
     self.$audioEl.each(function(index, element) {
       try {
        if (typeof(element.play) == 'function') {
          element.play();
        }
      } catch (err) {
        log.error('Error: '+ err);
      }
    });
     playedOnce = true;
     self.timeoutHandle = setTimeout(function() {
       delete self.timeoutHandle;
       self.stop();
     },895);
   };
   this.playIncorrect = function() {
    self.stop();
    if (playedOnce) {
     self.$audioEl.each(function(index, element) {
      try {
       element.currentTime = 3;
     } catch (err) {
       log.error('Error: '+ err);
     }
   });
   }
   self.$audioEl.each(function(index, element) {
     try {
        if (typeof(element.play) == 'function') {
          element.play();
        }
    } catch (err) {
      log.error('Error: '+ err);
    }
  });
   playedOnce = true;
   self.timeoutHandle = setTimeout(function() {
     delete self.timeoutHandle;
     self.stop();
   },757);
 };
};
return Sounds;

});



